function cov_msiio2to() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DoubleMove.tsx";
  var hash = "a0b90cc709fb58dd33a644a0af74242804db14f5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DoubleMove.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a0b90cc709fb58dd33a644a0af74242804db14f5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_msiio2to = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_msiio2to();
var Icon = (cov_msiio2to().s[0]++, {
  name: 'double-move',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 3.72165C2 2.21852 3.21852 1 4.72165 1H12.8866C14.3897 1 15.6082 2.21852 15.6082 3.72165V15.9691C15.6082 17.4722 14.3897 18.6907 12.8866 18.6907H4.72165C3.21852 18.6907 2 17.4722 2 15.9691V3.72165ZM12.7693 12.9044C12.9257 12.748 12.9257 12.4944 12.7693 12.338L10.5035 10.0722L12.7693 7.80636C12.9257 7.64994 12.9257 7.39633 12.7693 7.23991L11.6364 6.10701C11.48 5.95059 11.2263 5.95059 11.0699 6.10701L8.80412 8.37281L6.53832 6.10701C6.3819 5.95058 6.12829 5.95058 5.97187 6.10701L4.83897 7.23991C4.68254 7.39633 4.68254 7.64994 4.83897 7.80636L7.10477 10.0722L4.83897 12.338C4.68255 12.4944 4.68255 12.748 4.83897 12.9044L5.97187 14.0373C6.12829 14.1937 6.3819 14.1937 6.53832 14.0373L8.80412 11.7715L11.0699 14.0373C11.2263 14.1937 11.48 14.1937 11.6364 14.0373L12.7693 12.9044ZM16.5361 7.12371H18.3299C18.7057 7.12371 19.0103 7.42834 19.0103 7.80412V20.0515C19.0103 20.4273 18.7057 20.732 18.3299 20.732H10.6186C10.2428 20.732 9.93814 20.4273 9.93814 20.0515V19.4661H7.6701V20.0515C7.6701 21.6799 8.99017 23 10.6186 23H18.3299C19.9583 23 21.2784 21.6799 21.2784 20.0515V7.80412C21.2784 6.17574 19.9583 4.85567 18.3299 4.85567H16.5361V7.12371Z\" fill=\"currentColor\"/>"
});
export default Icon;